import React, { useEffect, useState, useContext } from 'react';
import SearchContext from '../../state/context';

const SearchSuggestions = ({
  controller,
  className = '',
  text,
  suggestedResultsLabel
}) => {
  const [state, setState] = useState(controller.state);

  const {
    onClickedSuggestion,
    numberOfSuggestions,
    resultsPageUrl,
    resultsPageLinkLabel
  } = useContext(SearchContext);

  useEffect(() => {
    controller.subscribe(() => setState(controller.state));
  }, []);

  useEffect(() => {
    if (text === '') {
      controller.clear();
      return;
    }
    controller.updateText(text);
  }, [text]);

  const getHighlightedSuggestion = textValue => {
    const regex = new RegExp(text, 'gi');
    return textValue.replace(regex, match => `<strong>${match}</strong>`);
  };

  return (
    <>
      {state.values.length > 0 && (
        <>
          <div className={className}>
            <div className="header-search-headless__coveo-suggestions-header">
              <svg viewBox="0 0 31 33" height="30" role="presentation">
                <use xlinkHref="#search"></use>
              </svg>
              <span>{suggestedResultsLabel}</span>
            </div>
            <ul>
              {state.values
                .slice(0, numberOfSuggestions)
                .map(facetSearchValue => (
                  <li key={facetSearchValue.rawValue}>
                    <button
                      className="header-search-headless__coveo-suggestion"
                      onClick={() =>
                        onClickedSuggestion(facetSearchValue.displayValue)
                      }
                    >
                      <span
                        dangerouslySetInnerHTML={{
                          __html: getHighlightedSuggestion(
                            facetSearchValue.displayValue
                          )
                        }}
                      />
                    </button>
                  </li>
                ))}
            </ul>
            <a
              className="header-search-headless__coveo-result-list-footer"
              href={resultsPageUrl ? resultsPageUrl : '#'}
            >
              <div className="header-search-headless__coveo-result-list-footer--link">
                <span>{resultsPageLinkLabel}</span>
                <svg viewBox="0 0 11 18" height="18" role="presentation">
                  <use xlinkHref="#arrow-right"></use>
                </svg>
              </div>
            </a>
          </div>
        </>
      )}
    </>
  );
};

export default SearchSuggestions;
